import * as React from 'react'
import {FC} from 'react'

const DefaultSeparator: FC<{}> = () => {
  return <div className='separator my-7'></div>
}

export default DefaultSeparator
